module.exports = __webpack_public_path__ + "img/LI.f56c72de.svg";